module.exports = __webpack_public_path__ + "img/vertical_4_6_8011.009a06f8.png";